import { combineReducers } from '@reduxjs/toolkit';
import itemsReducer from './items';
import appReducer from './app';
import userReducer from './user';
import userGroupsReducer from './userGroups';
import customersReducer from './customers';
import dashboardReducer from './dashboard';
import selectsReducer from './selects';
import warehousesReducer from './warehouses';
import additionalChargeInvoiceStylesReducer from './additionalChargeInvoiceStyles';
import additionalChargeUnitsReducer from './additionalChargeUnits';
import dispatcherGroupsReducer from './dispatcherGroups';
import expirationStatusesReducer from './expirationStatuses';
import fileTypesReducer from './fileTypes';
import laneRatesReducer from './laneRates';
import locationsReducer from './locations';
import marketsReducer from './markets';
import modalReducer from './modal';
import confirmDialogReducer from './confirmDialog';
import organizationsReducer from './organizations';
import quotesReducer from './quotes';
import quoteStatusesRedcuer from './quoteStatuses';
import quoteStatusVersionsReducer from './quoteStatusVersions';
import rateZonesReducer from './rateZones';
import statesReducer from './states';
import rolesReducer from './roles';
import warehouseManagersReducer from './warehouseManagerUsers';
import forkliftOperatorReducer from './forkliftOperatorUsers';
import safetyRepReducer from './safetyRepUsers';
import logisticCoordinatorsReducer from './logisticCoordinatorUsers';
import usersReducer from './users';
import additionalChargesReducer from './additionalCharges';
import opportunityTypesReducer from './opportunityTypes';
import quoteTypesReducer from './quoteTypes';
import orderImportReducer from './orderImport';
import deliveryTypesReducer from './deliveryTypes';
import rateTypesReducer from './rateTypes';
import pointTypesReducer from './pointTypes';
import schedulingTerminalsReducer from './schedulingTerminals';
import equipmentCategoryTypesReducer from './equipmentCategoryTypes';
import fuelTypesReducer from './fuelTypes';
import lienHoldersReducer from './lienHolders';
import countiesReducer from './counties';
import correctiveActionTypesReducer from './correctiveActionTypes';
import correctiveActionSubjectsReducer from './correctiveActionSubjects';
import activityTypesReducer from './activityTypes';
import cccStandardsReducer from './cccStandards';
import warehouseEquipmentTypesReducer from './warehouseEquipmentTypes';
import warehouseCCCCommoditiesReducer from './warehouseCCCCommodities';
import unitOfMeasuresReducer from './unitOfMeasures';
import cccStandardsShortInfosReducer from './cccStandardsShortInfos';
import warehousesLookupsReducer from './warehousesLookups';
import warehouseProductsReducer from './warehouseProducts';
import warehouseInfoOnOrderReducer from './warehouseInfoOnOrder';
import warehouseCCCTerminalTypesReducer from './warehouseCCCTerminalTypes';
import warehouseHoldReasonsReducer from './warehouseHoldReasons';
import warehouseAccountTypesReducer from './warehouseAccountTypes';
import warehouseReceivingTypesReducer from './warehouseReceivingTypes';
import warehouseOutboundModesReducer from './warehouseOutboundModes';
import assignmentStatusesReducer from './assignmentStatuses';
import quoteStorageTypesReducer from './quoteStorageTypes';
import moveTypesReducer from './moveTypes';
import equipmentSizesReducer from './equipmentSizes';
import handlingTypesReducer from './handlingTypes';
import toastReducer from './toast';
import fuelSurchargeTypesReducer from './fuelSurchargeTypes';
import fuelLaneRateTypesReducer from './fuelLaneRateTypes';
import fuelLaneInvoiceStylesReducer from './fuelLaneInvoiceStyles';
import messagingGroupsReducer from './messagingGroups';
import departmentsReducer from './departments';
// Driver
import distanceCategoriesReducer from './driver/distanceCategories';
import driverTypesReducer from './driver/driverTypes';
import driverMessagingPreferencesReducer from './driver/driverMessagingPreferences';
import driversReducer from './driver/drivers';
import endorsementTypesReducer from './driver/endorsementTypes';
import driverStatusTypesReducer from './driver/driverStatusTypes';
import driverStatusesReducer from './driver/driverStatuses';
import countriesReducer from './driver/countries';
import driverNotificationPreferencesReducer from './driver/driverNotificationPreferences';
// Truck
import truckStatusesReducer from './truckStatuses';
import truckMakesReducer from './truck/truckMakes';
import truckModelsReducer from './truck/truckModels';
import truckOOSReasonTypesReducer from './outOfServiceReasonTypes';
import ownerTypesReducer from './truck/ownerTypes';
import tireSizesReducer from './truck/tireSizes';
import rentalCompaniesReducer from './truck/rentalCompanies';
import inspectionTypesReducer from './truck/inspectionTypes';
// Insurance
import insuranceTypesReducer from './insurance/insuranceTypes';
import insuranceRatingsReducer from './insurance/insuranceRatings';
import insuranceSizeCategoriesReducer from './insurance/insuranceSizeCategories';
// GWI Equipment
import repairReasonsReducer from './repairReasons';
import repairStatusesReducer from './repairStatuses';
import equipmentTypesReducer from './equipmentTypes';
import equipmentConditionsReducer from './gwiEquipment/equipmentConditions';
import accountTypesReducer from './accountTypes';
// Safety Dashboard
import samsaraTagsReducer from './safetyDashboard/samsaraTags';
// Warehouse
import warehouseUnitTypesReducer from './warehouseUnitTypes';
import warehousesSchedulesReducer from './warehousesSchedules';
import handlingStandardsReducer from './handlingStandards';
import holdTypesReducer from './holdTypes';
import inventoryUnitsReducer from './inventoryUnits';
import carriersReducer from './carriers';
import checkInEquipmentTypesReducer from './checkInEquipmentTypes';
import addToBLTypesReducer from './addToBLTypes';
import pickPoliciesReducer from './pickPolicies';
import warehouseInstructionsTemplatesReducer from './warehouseInstructionsTemplates';
import externalCarriersReducer from './externalCarriers';
import traceTerminalsReducer from './traceTerminals';
import customerFSCTypesReducer from './customerFSCTypes';
import availabilityTypesReducer from './availabilityTypes';
import orderStatusesReducer from './orderStatuses';
import orderModesReducer from './orderModes';
import chassisPoolsReducer from './chassisPools';
import shipLinesReducer from './shipLines';
import portsReducer from './ports';
import temperatureScalesReducer from './temperatureScales';
import targetDeliveryDateTypesReducer from './targetDeliveryDateTypes';
import orderLegStopTypesReducer from './orderLegStopTypes';
import dispatchedDriverStatesReducer from './dispatchedDriverStates';
import documentTypesReducer from './documentTypes';
import poolTypesReducer from './poolTypes';
import bayLocationsReducer from './bayLocations';
import directStandardTypesReducer from './directStandardTypes';
import campusesReducer from './campuses';
import printerTypesReducer from './printerTypes';
import printersReducer from './printers';
import chargeCalculationTypesReducer from './chargeCalculationTypes';
import equipmentSubCategoryTypesReducer from './equipmentSubCategoryTypes';
import chassisLaneRateTypesReducer from './chassisLaneRateTypes';
// Driver Pay
import deductionRulesReducer from './driverPay/deductionRules';
import deductionsReducer from './driverPay/deductions';
import settlementsReducer from './driverPay/settlements';
import customerContactTypesReducer from './customerContactTypes';
import contactsNotificationsTypesReducer from './contactsNotificationsTypes';
import dispatchersReducer from './dispatchers';
import bookingHoldReducer from './bookingHold';
import faultReducer from './fault';
import dispatcherPreferencesReducer from './dispatcherPreferences';
import rateZoneTypesReducer from './rateZoneTypes';
import rateZoneLocationTypesReducer from './rateZoneLocationTypes';
import railbillingMethodsReducer from './railbillingMethods';
import orderSupportRequestsStatusesReducer from './orderSupportRequestsStatuses';
import volumeCommitmentsTypesReducer from './volumeCommitmentsTypes';
import tracingLineStatusesReducer from './tracingLineStatuses';
import tracingCustomStatusesReducer from './tracingCustomStatuses';
import unreadOrderSupportRequestReducer from './unreadOrderSupportRequests';
import truckTypesReducer from './truckTypes';
import organizationRolesReducer from './organizationRoles';
import accountStatusesReducer from './accountStatuses';
import accountingStatusesReducer from './accountingStatuses';
import contactTypesReducer from './contactTypes';
import salesRepsReducer from './salesReps';
import invoiceBatchingOptionsReducer from './invoiceBatchingOptions';
import invoiceDeliveryOptionsReducer from './invoiceDeliveryOptions';
import invoiceReferenceNumberTypesReducer from './invoiceReferenceNumberTypes';
import creditTermsReducer from './creditTerms';
import orderTypesReducer from './orderTypes';
import supportRequestsCategoriesReducer from './supportRequestsCategories';
import verticalsReducer from './verticals';
import lineItemTypesReducer from './lineItemTypes';
import chargeIntervalsReducer from './chargeIntervals';
import groundingLocationTypesReducer from './groundingLocationTypes';
import gwiLocationTypesReducer from './gwiLocationTypes';
import orderAdditionalCostTypesReducer from './orderAdditionalCostTypes';
import orderAdditionalCostStatusesReducer from './orderAdditionalCostStatuses';
import orderAdditionalCostLineItemPayStatusesReducer from './orderAdditionalCostLineItemPayStatuses';
import orderAdditionalCostLineItemDepartmentsReducer from './orderAdditionalCostLineItemDepartments';
import orderAdditionalCostLineItemReasonsReducer from './orderAdditionalCostLineItemReasons';
import repairOrderItemsReducer from './maintenance/repairOrderItems';
import repairOrderReportedByTypesReducer from './maintenance/repairOrderReportedByTypes';
import repairOrderStatusesReducer from './maintenance/repairOrderStatuses';
import repairLocationTypesReducer from './maintenance/repairLocationTypes';

import repairOrderTypesReducer from './maintenance/repairOrderTypes';
import repairOrderCategoriesReducer from './maintenance/repairOrderCategories';
import repairOrderIssuesReducer from './maintenance/repairOrderIssues';

import repairOrderTireAxlesReducer from './maintenance/repairOrderTireAxles';
import repairOrderTirePositionsReducer from './maintenance/repairOrderTirePositions';
import repairOrderTireSidesReducer from './maintenance/repairOrderTireSides';

import glCodeCategoriesReducer from './glCodeCategories';
import glCodeTypesReducer from './glCodeTypes';
import glTypesReducer from './glTypes';
import glCodesReducer from './glCodes';
import tracingLocationReducer from './traceLocations';
import v1OrganizationTypesReducer from './v1OrganizationTypes';
import DashboardViewTypesReducer from './dashboardViewTypes';
import BillFromValuesReducer from './billFromValues';
import FavoriteScheduledReportsReducer from './favoriteScheduledReports';
import noteTemplateTypesReducer from './noteTemplateTypes';
import noteTemplatesReducer from './noteTemplates';
import pendingOrderStatusesReducer from './pendingOrderStatuses';
import EnvironmentReducer from './environment';
import haulApprovalStatusesReducer from './haulApprovalStatuses';
import storeApprovalStatusesReducer from './storeApprovalStatuses';
import unHaulApprovalStatusesReducer from './unHaulApprovalStatuses';
import unStoreApprovalStatusesReducer from './unStoreApprovalStatuses';
import organizationCustomerTypesReducer from './organizationCustomerTypes';
import notificationTriggerTypesSliceReducer from './notificationTriggerTypes';
import hazmatUnsReducer from './hazmatUns';
import contractsOwnerTypesReducer from './contractsOwnerTypes';
import contactsReducer from './contacts';
import perDiemPastDueAcknowledgeReasonsReducer from './perDiemPastDueAcknowledgeReasons';
import inbondTypesReducer from './inbondTypes';
import responsiblePartyTypesReducer from './responsiblePartyTypes';
import contractAgreementTypesReducer from './contractAgreementTypes';
import contractAgreementParametersReducer from './contractAgreementParameters';
import quoteDeliveryTypesReducer from './quoteDeliveryTypes';
import fuelCalculationAppliesOnReducer from './fuelCalculationAppliesOn';
import quoteRateApplianceMethodsReducer from './quoteRateApplianceMethods';
import weightRulesReducer from './weightRules';
import quoteLaneSoldByTypesReducer from './quoteLaneSoldByTypes';
import quoteTripTypesReducer from './quoteTripTypes';
import invoiceBillingFrequenciesReducer from './invoiceBillingFrequencies';
import billedElsewhereReasonsReducer from './billedElsewhereReasons';
import fieldsToTrackReducer from './fieldsToTrack';
import invoicingHoldsReasonsReducer from './invoicingHoldsReasons';
import orderFieldsReducer from './orderFields';
// Page Storage
import pageStorageReducer from './pageStorage';

import truckPermitRulesReducer from './truckPermitRules';
import laneAdditionalChargeRateTypesReducer from './laneAdditionalChargeRateTypes';
import billingRequirementsReducer from './billingRequirements';
import pendingOrderFieldsReducer from './pendingOrderFields';

import messagingUrlReducer from './messagingUrl';
import lanesLookupReducer from './lanesLookup';
import pendingOrdersCreatedBy from './pendingOrdersCreatedBy';
import organizationTariffsUpdateFrequenciesReducer from './organizationTariffsUpdateFrequencies';

const rootReducer = combineReducers({
  app: appReducer,
  items: itemsReducer,
  user: userReducer,
  userGroups: userGroupsReducer,
  customers: customersReducer,
  dashboard: dashboardReducer,
  selects: selectsReducer,
  warehouses: warehousesReducer,
  additionalChargeInvoiceStyles: additionalChargeInvoiceStylesReducer,
  additionalChargeUnits: additionalChargeUnitsReducer,
  dispatcherGroups: dispatcherGroupsReducer,
  driverStatusTypes: driverStatusTypesReducer,
  driverStatuses: driverStatusesReducer,
  countries: countriesReducer,
  equipmentTypes: equipmentTypesReducer,
  expirationStatuses: expirationStatusesReducer,
  fileTypes: fileTypesReducer,
  laneRates: laneRatesReducer,
  locations: locationsReducer,
  markets: marketsReducer,
  modal: modalReducer,
  confirmDialog: confirmDialogReducer,
  orderImport: orderImportReducer,
  organizations: organizationsReducer,
  quotes: quotesReducer,
  quoteStatuses: quoteStatusesRedcuer,
  quoteStatusVersions: quoteStatusVersionsReducer,
  rateZones: rateZonesReducer,
  states: statesReducer,
  truckStatuses: truckStatusesReducer,
  roles: rolesReducer,
  warehousemanagers: warehouseManagersReducer,
  logisticcoordinators: logisticCoordinatorsReducer,
  safetyreps: safetyRepReducer,
  forkliftoperators: forkliftOperatorReducer,
  users: usersReducer,
  additionalCharges: additionalChargesReducer,
  opportunityTypes: opportunityTypesReducer,
  quoteTypes: quoteTypesReducer,
  deliveryTypes: deliveryTypesReducer,
  rateTypes: rateTypesReducer,
  pointTypes: pointTypesReducer,
  ownerTypes: ownerTypesReducer,
  tireSizes: tireSizesReducer,
  schedulingTerminals: schedulingTerminalsReducer,
  equipmentCategoryTypes: equipmentCategoryTypesReducer,
  repairReasons: repairReasonsReducer,
  repairStatuses: repairStatusesReducer,
  truckMakes: truckMakesReducer,
  truckModels: truckModelsReducer,
  outOfServiceReasonTypes: truckOOSReasonTypesReducer,
  fuelTypes: fuelTypesReducer,
  lienHolders: lienHoldersReducer,
  counties: countiesReducer,
  distanceCategories: distanceCategoriesReducer,
  driverTypes: driverTypesReducer,
  driverMessagingPreferences: driverMessagingPreferencesReducer,
  drivers: driversReducer,
  correctiveActionTypes: correctiveActionTypesReducer,
  correctiveActionSubjects: correctiveActionSubjectsReducer,
  activityTypes: activityTypesReducer,
  cccStandards: cccStandardsReducer,
  warehouseEquipmentTypes: warehouseEquipmentTypesReducer,
  warehouseCCCCommodities: warehouseCCCCommoditiesReducer,
  endorsementTypes: endorsementTypesReducer,
  unitOfMeasures: unitOfMeasuresReducer,
  cccStandardsShortInfos: cccStandardsShortInfosReducer,
  warehousesLookups: warehousesLookupsReducer,
  warehouseProducts: warehouseProductsReducer,
  warehouseInfoOnOrder: warehouseInfoOnOrderReducer,
  warehouseCCCTerminalTypes: warehouseCCCTerminalTypesReducer,
  warehouseHoldReasons: warehouseHoldReasonsReducer,
  warehouseAccountTypes: warehouseAccountTypesReducer,
  warehouseReceivingTypes: warehouseReceivingTypesReducer,
  warehouseOutboundModes: warehouseOutboundModesReducer,
  assignmentStatuses: assignmentStatusesReducer,
  insuranceTypes: insuranceTypesReducer,
  insuranceRatings: insuranceRatingsReducer,
  insuranceSizeCategories: insuranceSizeCategoriesReducer,
  handlingStandards: handlingStandardsReducer,
  handlingTypes: handlingTypesReducer,
  equipmentSizes: equipmentSizesReducer,
  equipmentConditions: equipmentConditionsReducer,
  quoteStorageTypes: quoteStorageTypesReducer,
  accountTypes: accountTypesReducer,
  samsaraTags: samsaraTagsReducer,
  moveTypes: moveTypesReducer,
  warehouseUnitTypes: warehouseUnitTypesReducer,
  rentalCompanies: rentalCompaniesReducer,
  inspectionTypes: inspectionTypesReducer,
  warehousesSchedules: warehousesSchedulesReducer,
  holdTypes: holdTypesReducer,
  inventoryUnits: inventoryUnitsReducer,
  addToBLTypes: addToBLTypesReducer,
  pickPolicies: pickPoliciesReducer,
  carriers: carriersReducer,
  checkInEquipmentTypes: checkInEquipmentTypesReducer,
  toast: toastReducer,
  warehouseInstructionsTemplates: warehouseInstructionsTemplatesReducer,
  fuelSurchargeTypes: fuelSurchargeTypesReducer,
  externalCarriers: externalCarriersReducer,
  traceTerminals: traceTerminalsReducer,
  customerFSCTypes: customerFSCTypesReducer,
  availabilityTypes: availabilityTypesReducer,
  orderStatuses: orderStatusesReducer,
  orderModes: orderModesReducer,
  chassisPools: chassisPoolsReducer,
  shipLines: shipLinesReducer,
  ports: portsReducer,
  temperatureScales: temperatureScalesReducer,
  targetDeliveryDateTypes: targetDeliveryDateTypesReducer,
  orderLegStopTypes: orderLegStopTypesReducer,
  dispatchedDriverStates: dispatchedDriverStatesReducer,
  documentTypes: documentTypesReducer,
  poolTypes: poolTypesReducer,
  bayLocations: bayLocationsReducer,
  directStandardTypes: directStandardTypesReducer,
  deductionRules: deductionRulesReducer,
  deductions: deductionsReducer,
  campuses: campusesReducer,
  printerTypes: printerTypesReducer,
  printers: printersReducer,
  settlements: settlementsReducer,
  chargeCalculationTypes: chargeCalculationTypesReducer,
  fuelLaneRateTypes: fuelLaneRateTypesReducer,
  messagingGroups: messagingGroupsReducer,
  departments: departmentsReducer,
  customerContactTypes: customerContactTypesReducer,
  contactsNotificationsTypes: contactsNotificationsTypesReducer,
  equipmentSubCategoryTypes: equipmentSubCategoryTypesReducer,
  chassisLaneRateTypes: chassisLaneRateTypesReducer,
  orderSupportRequestsStatuses: orderSupportRequestsStatusesReducer,
  dispatchers: dispatchersReducer,
  bookingHold: bookingHoldReducer,
  fault: faultReducer,
  dispatcherPreferences: dispatcherPreferencesReducer,
  rateZoneTypes: rateZoneTypesReducer,
  rateZoneLocationTypes: rateZoneLocationTypesReducer,
  railbillingMethods: railbillingMethodsReducer,
  volumeCommitmentsTypes: volumeCommitmentsTypesReducer,
  tracingLineStatuses: tracingLineStatusesReducer,
  tracingCustomStatuses: tracingCustomStatusesReducer,
  unreadOrderSupportRequests: unreadOrderSupportRequestReducer,
  driverNotificationPreferences: driverNotificationPreferencesReducer,
  truckTypes: truckTypesReducer,
  organizationRoles: organizationRolesReducer,
  accountStatuses: accountStatusesReducer,
  accountingStatuses: accountingStatusesReducer,
  contactTypes: contactTypesReducer,
  salesReps: salesRepsReducer,
  invoiceBatchingOptions: invoiceBatchingOptionsReducer,
  invoiceDeliveryOptions: invoiceDeliveryOptionsReducer,
  invoiceReferenceNumberTypes: invoiceReferenceNumberTypesReducer,
  creditTerms: creditTermsReducer,
  orderTypes: orderTypesReducer,
  supportRequestsCategories: supportRequestsCategoriesReducer,
  verticals: verticalsReducer,
  lineItemTypes: lineItemTypesReducer,
  chargeIntervals: chargeIntervalsReducer,
  orderAdditionalCostTypes: orderAdditionalCostTypesReducer,
  orderAdditionalCostStatuses: orderAdditionalCostStatusesReducer,
  orderAdditionalCostLineItemPayStatuses: orderAdditionalCostLineItemPayStatusesReducer,
  orderAdditionalCostLineItemDepartments: orderAdditionalCostLineItemDepartmentsReducer,
  orderAdditionalCostLineItemReasons: orderAdditionalCostLineItemReasonsReducer,
  repairOrderItems: repairOrderItemsReducer,
  repairOrderReportedByTypes: repairOrderReportedByTypesReducer,
  repairOrderStatuses: repairOrderStatusesReducer,
  repairLocationTypes: repairLocationTypesReducer,
  repairOrderTypes: repairOrderTypesReducer,
  repairOrderCategories: repairOrderCategoriesReducer,
  repairOrderIssues: repairOrderIssuesReducer,
  repairOrderTireAxles: repairOrderTireAxlesReducer,
  repairOrderTirePositions: repairOrderTirePositionsReducer,
  repairOrderTireSides: repairOrderTireSidesReducer,
  groundingLocationTypes: groundingLocationTypesReducer,
  gwiLocationTypes: gwiLocationTypesReducer,
  glCodeCategories: glCodeCategoriesReducer,
  glCodeTypes: glCodeTypesReducer,
  glTypes: glTypesReducer,
  glCodes: glCodesReducer,
  v1OrganizationTypes: v1OrganizationTypesReducer,
  tracingLocations: tracingLocationReducer,
  pageStorage: pageStorageReducer,
  dashboardViewTypes: DashboardViewTypesReducer,
  billFromValues: BillFromValuesReducer,
  favoriteScheduledReports: FavoriteScheduledReportsReducer,
  noteTemplateTypes: noteTemplateTypesReducer,
  noteTemplates: noteTemplatesReducer,
  pendingOrderStatuses: pendingOrderStatusesReducer,
  environment: EnvironmentReducer,
  haulApprovalStatuses: haulApprovalStatusesReducer,
  storeApprovalStatuses: storeApprovalStatusesReducer,
  unHaulApprovalStatuses: unHaulApprovalStatusesReducer,
  unStoreApprovalStatuses: unStoreApprovalStatusesReducer,
  organizationCustomerTypes: organizationCustomerTypesReducer,
  notificationTriggerTypes: notificationTriggerTypesSliceReducer,
  hazmatUns: hazmatUnsReducer,
  contractsOwnerTypes: contractsOwnerTypesReducer,
  contacts: contactsReducer,
  fieldsToTrack: fieldsToTrackReducer,
  perDiemPastDueAcknowledgeReasons: perDiemPastDueAcknowledgeReasonsReducer,
  inbondTypes: inbondTypesReducer,
  responsiblePartyTypes: responsiblePartyTypesReducer,
  quoteDeliveryTypes: quoteDeliveryTypesReducer,
  fuelLaneInvoiceStyles: fuelLaneInvoiceStylesReducer,
  contractsAgreementTypes: contractAgreementTypesReducer,
  contractsAgreementParameters: contractAgreementParametersReducer,
  fuelCalculationAppliesOn: fuelCalculationAppliesOnReducer,
  quoteRateApplianceMethods: quoteRateApplianceMethodsReducer,
  weightRules: weightRulesReducer,
  quoteLaneSoldByTypes: quoteLaneSoldByTypesReducer,
  quoteTripTypes: quoteTripTypesReducer,
  invoiceBillingFrequencies: invoiceBillingFrequenciesReducer,
  billedElsewhereReasons: billedElsewhereReasonsReducer,
  truckPermitRules: truckPermitRulesReducer,
  laneAdditionalChargeRateTypes: laneAdditionalChargeRateTypesReducer,
  billingRequirements: billingRequirementsReducer,
  invoicingHoldsReasons: invoicingHoldsReasonsReducer,
  orderFields: orderFieldsReducer,
  pendingOrderFields: pendingOrderFieldsReducer,
  pendingOrdersCreatedBy,
  messagingUrl: messagingUrlReducer,
  lanesLookup: lanesLookupReducer,
  organizationTariffsUpdateFrequencies: organizationTariffsUpdateFrequenciesReducer
});

export default rootReducer;
